import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { useWindowWidth, useWindowHeight } from "@react-hook/window-size";
import Panel from "../panel";

const AboutUs = ({ isOpen, manageWindow, lang }) => {
  const width = useWindowWidth();
  const height = useWindowHeight();

  const data = useStaticQuery(graphql`
    {
      allMdx(
        filter: { frontmatter: { slug: { eq: "/about-us" } } }
        sort: { fields: frontmatter___lang }
      ) {
        edges {
          node {
            body
            frontmatter {
              lang
            }
          }
        }
      }
    }
  `);

  return (
    <>
      {isOpen && (
        <Panel
          title="About Us"
          content={data.allMdx.edges[lang].node.body}
          onClose={() => manageWindow("About Us", false)}
          width={width < 768 ? 310 : 600}
          height={width < 768 ? 520 : 600}
          position={{
            x: Math.max((width - (width < 768 ? 310 : 900)) / 2 + (width < 768 ? 0 : -120), 10),
            y: Math.max((height - (width < 768 ? 520 : 580)) / 2 + (width < 768 ? 0 : 60), 30),
          }}
        />
      )}
    </>
  );
};

export default AboutUs;
